// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

// get icon by name from public folder
const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: <Iconify icon="la:user" />,
  store: <Iconify icon="bi:cart2" />,
  guide: <Iconify icon="iconoir:headset-help" />,
  mystic: <Iconify icon="line-md:sunny-outline-to-moon-alt-loop-transition" />,
  invoice: <Iconify icon="la:book-open" />,
  dashboard: <Iconify icon="la:buffer" />,
  mycolab: <Iconify icon="mdi:mushroom" />,
  organizations: <Iconify icon="la:building" />,
  recipes: <Iconify icon="mdi:flask" />,
  batches: <Iconify icon="mdi:cube-outline" />,
  stages: <Iconify icon="mdi:stairs" />,
  monitoring: <Iconify icon="mdi:monitor-dashboard" />,
  alerts: <Iconify icon="mdi:alert-circle-outline" />,
  notes: <Iconify icon="mdi:note-text" />,
  archives: <Iconify icon="mdi:archive" />,
  sensors: <Iconify icon="mdi:access-point" />,
  apiKeys: <Iconify icon="mdi:key-variant" />,
  library: <Iconify icon="mdi:bookshelf" />,
  settings: <Iconify icon="mdi:cog" />,
  developers: <Iconify icon="mdi:code-braces" />,
  apiDocs: <Iconify icon="mdi:file-document-outline" />,
  telegram: <Iconify icon="mdi:telegram" />,
  language: <Iconify icon="mdi:translate" />,
};

export default function getNavConfig() {
  return ([
    // APPS
    // ----------------------------------------------------------------------
    {
      subheader: 'nav.subheader.apps',
      items: [
        // General - Dashboard (moved from /dashboard/app to /dashboard)
        { title: 'nav.general.app', path: PATH_DASHBOARD.root, icon: ICONS.dashboard },


        // MycoLab
        {
          title: 'nav.mycolab.title', path: PATH_DASHBOARD.mycolab.root, icon: ICONS.mycolab,
          children: [
            { title: 'nav.mycolab.organizations', path: PATH_DASHBOARD.mycolab.organizations, icon: ICONS.organizations },
            { title: 'nav.mycolab.library', path: PATH_DASHBOARD.mycolab.library, icon: ICONS.library },
            { title: 'nav.mycolab.recipes', path: PATH_DASHBOARD.mycolab.recipes, icon: ICONS.recipes },
            { title: 'nav.mycolab.batches', path: PATH_DASHBOARD.mycolab.batches, icon: ICONS.batches },
            { title: 'nav.mycolab.stages', path: PATH_DASHBOARD.mycolab.stages, icon: ICONS.stages },
            { title: 'nav.mycolab.monitoring', path: PATH_DASHBOARD.mycolab.monitoring, icon: ICONS.monitoring },
            { title: 'nav.mycolab.alerts', path: PATH_DASHBOARD.mycolab.alerts, icon: ICONS.alerts },
            { title: 'nav.mycolab.notes', path: PATH_DASHBOARD.mycolab.notes, icon: ICONS.notes },
            { title: 'nav.mycolab.archives', path: PATH_DASHBOARD.mycolab.archives, icon: ICONS.archives },
            { title: 'nav.mycolab.sensors', path: PATH_DASHBOARD.mycolab.sensors, icon: ICONS.sensors },
            { title: 'nav.mycolab.apiKeys', path: PATH_DASHBOARD.mycolab.apiKeys, icon: ICONS.apiKeys },
            { title: 'nav.mycolab.settings', path: PATH_DASHBOARD.mycolab.settings, icon: ICONS.settings },
          ],
        },


      ]
    },

    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: 'nav.subheader.general',
      items: [
        // GAMIFICATION
        {
          title: 'nav.gamification.title',
          icon: <Iconify icon="mdi:trophy" />,
          path: PATH_DASHBOARD.gamification.root,
          children: [
            { title: 'nav.gamification.dashboard', path: PATH_DASHBOARD.gamification.root },
            { title: 'nav.gamification.achievements', path: PATH_DASHBOARD.gamification.achievements },
            { title: 'nav.gamification.leaderboard', path: PATH_DASHBOARD.gamification.leaderboard },
            { title: 'nav.gamification.challenges', path: PATH_DASHBOARD.gamification.challenges },
          ],
        },

        // USER
        {
          title: 'nav.user.title',
          icon: ICONS.user,
          path: PATH_DASHBOARD.user.root,
          children: [
            { title: 'nav.user.profile', path: PATH_DASHBOARD.user.account },
            { title: 'nav.user.payments', path: PATH_DASHBOARD.user.store },
          ],
        },

        // SETTINGS
        {
          title: 'nav.settings.title',
          icon: ICONS.settings,
          path: PATH_DASHBOARD.settings.root,
          children: [
            { title: 'nav.settings.telegram', path: PATH_DASHBOARD.settings.telegram, icon: ICONS.telegram },
            { title: 'nav.settings.language', path: PATH_DASHBOARD.settings.language, icon: ICONS.language },
          ],
        },

        // STORE
        {
          title: 'nav.shop.title',
          path: PATH_DASHBOARD.shop.root,
          icon: ICONS.store,
          children: [
            { title: 'nav.shop.cart', path: PATH_DASHBOARD.shop.checkout },
            { title: 'nav.shop.products', path: PATH_DASHBOARD.shop.products },
            { title: 'nav.shop.orders', path: PATH_DASHBOARD.shop.orders },
            { title: 'nav.shop.memberships', path: PATH_DASHBOARD.shop.memberships },
          ],
        },

        // COMMUNITY
        {
          title: 'nav.community.title',
          path: 'https://t.me/+9oNNcUWQEa40ZTRh',
          icon: ICONS.telegram,
          children: [
            { title: 'nav.community.channel', path: 'https://t.me/SporExpertLatam' },
            { title: 'nav.community.group', path: 'https://t.me/+9oNNcUWQEa40ZTRh' },
          ],
        },

        // SUPPORT
        {
          title: 'nav.support.title',
          path: PATH_DASHBOARD.support.guide,
          icon: ICONS.guide,
          children: [
            { title: 'nav.support.guide', path: PATH_DASHBOARD.support.guide },
            { title: 'nav.support.chat', path: PATH_DASHBOARD.support.chat },
          ],
        },

        // DEVELOPERS
        {
          title: 'nav.developers.title',
          path: PATH_DASHBOARD.developers.api,
          icon: ICONS.developers,
          children: [
            { title: 'nav.developers.api_docs', path: PATH_DASHBOARD.developers.api, icon: ICONS.apiDocs },
          ],
        },
      ]
    }
  ]);
}
